import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CustomItemState } from './custom-item.reducers';

// tslint:disable: max-line-length
export const customItemFeatureStateSelector = createFeatureSelector<CustomItemState>('customItem');

export const selectCustomItems = createSelector(customItemFeatureStateSelector, (state: CustomItemState) => state.items);
export const selectCustomItemsTotalCount = createSelector(
  customItemFeatureStateSelector,
  (state: CustomItemState) => state.itemsTotalCount,
);
export const selectCustomItemsFindParams = createSelector(customItemFeatureStateSelector, (state: CustomItemState) => state.findParams);

export const selectCustomItem = createSelector(customItemFeatureStateSelector, (state: CustomItemState) => state.item);
